import React from 'react'
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

class PasswordField extends React.PureComponent {
  state = {
    showPassword: false
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  }

  render() {
    const {className, ...props} = this.props
    const errorClass = this.props.error ? 'InputWithErrors' : 'InputFocusLabel'
    const newClassName = `${className} ${errorClass}`
    return (
      <TextField
        {...props}
        className={newClassName}
        type={this.state.showPassword ? 'text' : 'password'}
        FormHelperTextProps={{
          classes: {
            root: 'TextInputHelperText',
            error: 'TextInput-error'
          }
        }}
        InputProps={{
          classes: {
            error: 'TextInputContainer-error'
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                tabIndex="-1"
                aria-label="Toggle password visibility"
                onClick={this.handleClickShowPassword}
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    )
  }
}

export default PasswordField



// WEBPACK FOOTER //
// ./src/js/components/inputs/PasswordField.js